export enum UserTaskPriority {
  Low = 1,
  Medium = 2,
  High = 3,
}

export const UserTaskPriorityLabels: Record<UserTaskPriority, string> = {
  [UserTaskPriority.Low]: "Low Priority",
  [UserTaskPriority.Medium]: "Medium Priority",
  [UserTaskPriority.High]: "High Priority",
};
